<template>
  <div id="knowledge">
    <div class="columns">
      <div class="column">
        <div class="notification" v-if="loading">Laden...</div>

        <div class="error" v-if="errors">{{ errors }}</div>
      </div>
    </div>

    <div class="columns">
      <div class="column is-half">
        <div class="field">
          <div class="control">
            <input type="text" class="input" v-model="query" placeholder="zoeken">
          </div>
        </div>
      </div>

      <div class="column is-one-quarter is-offset-one-quarter">
        <router-link
        class="button"
        v-if="myKnowledgeItems.length > 0 || isAdmin"
        :to="{ name: 'knowledge-edit', params: { id: false } }"
        >Nieuw kennisitem</router-link>
      </div>
    </div>

    <div class="columns">
      <div class="column is-half">
        <div v-if="myKnowledgeItems.length === 0 && isSupplier" class="notification">
          Hier kun je nieuwe kennisdocumenten toevoegen aan de Droombronnenbank. Er staan nog geen documenten in de Droombronnenbank van {{ this.accountData.supplier.name }}. Klik <router-link :to="{ name: 'knowledge-edit', params: { id: false } }">hier</router-link> om een document toe te voegen.
        </div>

        <div class="box" v-for="item in myKnowledgeItems" :key="item.id" >
          <router-link :to="{ name: 'knowledge-edit', params: { id: item.id } }">{{ item.title }}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import { bus } from '@/main'

  export default {
    data() {
      return {
        loading: false,
        knowledgeItems: [],
        errors: null,
        query: ''
      };
    },
    computed: {
      isAdmin () {
        return this.$store.getters.isAdmin
      },
      isSupplier () {
        return this.$store.getters.isSupplier
      },
      accountData () {
        return this.$store.getters.accountData
      },
      params () {
        return this.$store.getters.params
      },
      myKnowledgeItems () {
        if (this.accountData.level_id === 1) {
          return this.knowledgeItems.filter(item => item.title.toLowerCase().includes(this.query.toLowerCase()))
        }

        return this.knowledgeItems.filter((item) => {
          return item.supplier_id === this.accountData.supplier.id&&
            item.title.toLowerCase().includes(this.query.toLowerCase())
        })
      }
    },
    created () {
      this.fetchData()
    },
    // TODO: The backend should only return products that the user has access to based on it's access token.
    methods: {
      fetchData () {
        this.loading = true;
        axios
          .get('/knowledge')
          .then(response => {
            this.loading = false
            this.knowledgeItems = response.data
          }).catch(error => {
            this.loading = false
            this.error = error.response.data.message || error.message
          });
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/knowledge/KnowledgeItems.vue